import { IAnalyticsDailySuccessful, IAnalyticsOverview, IAnalyticsTopOrganization, RootState } from '@/types/types';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { isNetworkError } from '@/utils/helpers';
import { ReportingService } from '@/services/reporting.service';

interface AnalyticsState {
  dailySuccessful: IAnalyticsDailySuccessful | null;
  topOrganizations: IAnalyticsTopOrganization[];
  overview: IAnalyticsOverview | null;
}

const state: AnalyticsState = {
  dailySuccessful: null,
  topOrganizations: [],
  overview: null,
};

const mutations: MutationTree<AnalyticsState> = {
  UPDATE_DAILY_SUCCESSFUL(state, payload: IAnalyticsDailySuccessful) {
    state.dailySuccessful = payload;
  },
  UPDATE_TOP_ORGANIZATIONS(state, payload: IAnalyticsTopOrganization[]) {
    state.topOrganizations = payload;
  },
  UPDATE_OVERVIEW(state, payload: IAnalyticsOverview) {
    state.overview = payload;
  },
};

const actions: ActionTree<AnalyticsState, RootState> = {
  async fetchDailySuccessful({ dispatch, commit }, query: string) {
    try {
      dispatch('isPageLoading', true, { root: true });
      const response$ = await ReportingService.analyticsDailySuccessful(query);
      commit('UPDATE_DAILY_SUCCESSFUL', response$.data?.data);
      dispatch('isPageLoading', false, { root: true });
    } catch (e) {
      dispatch('snackBarMessage', isNetworkError(e) ? e?.message : e.response?.data?.supportMessage, { root: true });
      dispatch('snackBarVisibility', true, { root: true });
      dispatch('isPageLoading', false, { root: true });
    }
  },
  async fetchTopOrganizations({ dispatch, commit }, query: string) {
    try {
      dispatch('isPageLoading', true, { root: true });
      const response$ = await ReportingService.analyticsTopOrganizations(query);
      commit('UPDATE_TOP_ORGANIZATIONS', response$.data?.data?.organizations ?? []);
      dispatch('isPageLoading', false, { root: true });
    } catch (e) {
      dispatch('snackBarMessage', isNetworkError(e) ? e?.message : e.response?.data?.supportMessage, { root: true });
      dispatch('snackBarVisibility', true, { root: true });
      dispatch('isPageLoading', false, { root: true });
    }
  },
  async fetchOverview({ dispatch, commit }, query: string) {
    try {
      dispatch('isPageLoading', true, { root: true });
      const response$ = await ReportingService.analyticsDailyOverview(query);
      commit('UPDATE_OVERVIEW', response$.data?.data);
      dispatch('isPageLoading', false, { root: true });
    } catch (e) {
      dispatch('snackBarMessage', isNetworkError(e) ? e?.message : e.response?.data?.supportMessage, { root: true });
      dispatch('snackBarVisibility', true, { root: true });
      dispatch('isPageLoading', false, { root: true });
    }
  },
};

const getters: GetterTree<AnalyticsState, RootState> = {
  getDailySuccessful: state => state.dailySuccessful,
  getTopOrganizations: state => state.topOrganizations,
  getOverview: state => state.overview,
};

export const analytics: Module<AnalyticsState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
